import { useLazyQuery } from '@apollo/client';
import { GET_SEARCH_KEY } from 'graph_ql/search/get_search_key.gql';
import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { getSearchKey } from '__generated__/getSearchKey';
import { useAlgolia } from '.';
import { auth } from '../../firebase';
import { setSetSearchKey } from './slice';

export const AlgoliaProvider: FC<PropsWithChildren> = (props) => {
    const { children } = props;
    const dispatch = useDispatch();
    const [currentUser, setCurrentUser] = useState<any>({});
    const me = useSelector((state: RootState) => state.userDetail.me);
    useAlgolia();
    const [getSearchKeyFuc] = useLazyQuery<getSearchKey, any>(GET_SEARCH_KEY, {
        fetchPolicy: 'network-only',
        context: {
            scope: 'private',
            approved: true,
        },
    });

    useEffect(() => {
        auth.onAuthStateChanged(async (user) => {
            if (user) {
                setCurrentUser(user);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        const retrieveSearchKey = async () => {
            try {
                const res = await getSearchKeyFuc();
                localStorage.setItem('ALGOLIA_TOKEN', res?.data?.getSearchKey?.token || '');
                dispatch(setSetSearchKey(res?.data?.getSearchKey?.token || ''));
            } catch (e) {
                console.error(e);
            }
        };
        console.log('currentUser', currentUser);
        if (
            currentUser &&
            me &&
            currentUser?.uid === me?.id &&
            localStorage &&
            !localStorage.getItem('ALGOLIA_TOKEN')
        ) {
            retrieveSearchKey();
        }
        // })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [me, currentUser]);
    return <>{children}</>;
};
